/*
 * 工单数据-订单故障占比--故障订单
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import ScGridTable from "@/components/display/table/gridTableCore";
import { queryOrderCountDetail } from "@/fetch/fetchApi";

class FaultOrderList extends Component {
  state = {
    tableConfig: null,
  };

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    const modalParam = this.context.store.getState().modalInfo.param;
    this.setState({
      tableConfig: {
        tableKey: "faultOrderTable",
        tableColumns: [
          {
            name: "订单编号",
            key: "orderId",
            colType: "textCol",
            align: "center",
          },
          {
            name: "场站名称",
            key: "stubGroupName",
            colType: "textCol",
            align: "center",
          },
          {
            name: "设备编号",
            key: "stubId",
            colType: "textCol",
            align: "center",
          },
          {
            name: "故障原因",
            key: "endInfo",
            colType: "textCol",
            align: "center",
          },
        ],
        tableChange: () => {},
        tableParam: {
          pagecount: 10,
          ...modalParam,
        },
        dataApi: queryOrderCountDetail,
        autoRefresh: true, // 设置为true 直接加载grid数据
      },
    });
  }

  render() {
    return <ScGridTable config={this.state.tableConfig} />;
  }
}

export default FaultOrderList;



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/chargeSuccessRate/detail/faultOrder.js